/**
 * Status Indicator Component
 * 
 * Phase 1A: Visual status badge for PASS/WARNING/CRITICAL states.
 */
import { CheckCircle, AlertTriangle, XCircle, HelpCircle } from "lucide-react";

const STATUS_CONFIG = {
  pass: {
    bg: "bg-green-500/20",
    border: "border-green-500",
    text: "text-green-400",
    icon: CheckCircle,
  },
  warning: {
    bg: "bg-yellow-500/20",
    border: "border-yellow-500",
    text: "text-yellow-400",
    icon: AlertTriangle,
  },
  critical: {
    bg: "bg-red-500/20",
    border: "border-red-500",
    text: "text-red-400",
    icon: XCircle,
  },
  unknown: {
    bg: "bg-slate-500/20",
    border: "border-slate-500",
    text: "text-slate-400",
    icon: HelpCircle,
  },
  info: {
    bg: "bg-blue-500/20",
    border: "border-blue-500",
    text: "text-blue-400",
    icon: CheckCircle,
  },
};

export default function StatusIndicator({ status = "unknown", label, showIcon = true, size = "md" }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.unknown;
  const Icon = config.icon;
  
  const sizeClasses = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-3 py-1",
    lg: "text-base px-4 py-2",
  };

  return (
    <span 
      className={`inline-flex items-center gap-1.5 rounded-full border ${config.bg} ${config.border} ${config.text} ${sizeClasses[size]} font-medium`}
      data-testid={`status-${status}`}
    >
      {showIcon && <Icon className={size === "sm" ? "w-3 h-3" : "w-4 h-4"} />}
      {label}
    </span>
  );
}
